import React, { Component } from 'react';

import AddAccount from '../PlaidLink/AddAccount';
import UserService from '../../../Service/UserService';
import AccountService from '../../../Service/AccountService';
import { toastError } from '../../../SweetAlertUtil/util';
import { logPageView } from '../../../AppUtil/analytics';
import { withTranslation } from 'react-i18next';
import { setNavigationalWindowObject, deleteNavigationalWindowObject } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

const SESSION_KEY = window.AppConfig.CONST_KEYS;
class Plaid extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isPlaidProcessing: false
		};
	}

	handleOnBankAdd = async response => {
		if (response) {
			if (response.error === SESSION_KEY.SESSION_EXPIRED) return;
			if (!response.status) {
				toastError(response.data);
				return;
			}
		} else {
			await AccountService.updatePlaidSatus();
		}
		const currentUser = await UserService.updateCurrentUser();
		await this.props.setCurrentUser(currentUser);
		await this.props.onClose();
		logPageView('/app/plaid-link-created'); // NOSONAR
		this.setState({
			_isPlaidProcessing: false
		});
	};

	componentDidMount() {
		const dataForPopUp = {
			title: 'sweetalert_title.wait',
			messageKey: 'sweetalert.continue_on_plaid',
			message: {},
			label: ['using_bank_accounts']
		};
		setNavigationalWindowObject(dataForPopUp);
	}

	componentWillUnmount() {
		deleteNavigationalWindowObject();
	}

	render() {
		const { t } = this.props;
		return (
			<div className="demo-container mdl-grid">
				<div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
				<div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
					<div className="mdl-grid">
						<div className="mdl-cell mdl-cell--12-col center-items">
							<h4 className="text-center main-top-heading">
								{!this.state._isPlaidProcessing
									? t('plaid_screen_title_before')
									: t('plaid_screen_title_after')}
							</h4>
						</div>
					</div>
					<div className="mdl-grid center-items">
						<div className="mdl-cell mdl-cell--10-col ">
							<div className="mdl-cell mdl-cell--12-col text-center">
								<AddAccount
									OnClose={this.handleOnBankAdd}
									OnExit={() => this.props.onClose()}
									OnStart={() => {
										this.setState({ _isPlaidProcessing: true });
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default hot(module)(withTranslation(['DwollaPlaid'])(Plaid));
